/* global sessionStorage */

import { $ } from '../utils/query-selector.js'
import dialogPolyfill from 'dialog-polyfill/index.js'

const STORAGE_KEY = 'announcement-dismissed'
const $el = $('.js-announcement')

if ($el) {
  dialogPolyfill.registerDialog($el)
  const hash = $el.dataset.hash
  const dismissedHash = sessionStorage.getItem(STORAGE_KEY)

  if (hash !== dismissedHash) {
    $el.showModal()
  }

  const cb = () => {
    sessionStorage.setItem(STORAGE_KEY, hash)
  }

  $el.addEventListener('close', cb)
  $('a', $el).addEventListener('click', cb)
}
